//const dotenv = require("dotenv");
//dotenv.config();

import { faL } from "@fortawesome/free-solid-svg-icons";

//const backendUrl = 'http://localhost:3000';
export const backendUrl = process.env.REACT_APP_BACKENDURL;
//const backendUrl = "https://singlepdf-qa.azurewebsites.net";
export const apiVersion = "v2";
export const customerName = sessionStorage.getItem("customerName") || window.location.host.split(".")[0];

export const backendUrls = {
  configUrl: backendUrl + "/config",
  pdfMergeUrl: backendUrl + "/PDFMerge",
  oidcConfigUrl: backendUrl + "/oidcConfig",
};

export const APP_COMPONENT_DOCUMENTS_VIEWER_PATH = "/pdfviewer/viewer.html";
export const APP_COMPONENT_DOCUMENTS_VIEWER_USE_BUILDIN_DESKTOP = false;
